<script lang="ts">
  import type { SelectionsReadManyResponse } from '@entities/selection';

  import { SelectionList } from '@widgets/selection-list';

  export let selectionsData: SelectionsReadManyResponse;
  export let artistName: string;
</script>

<section>
  <h3 class="mb-2.5 py-4 text-lg font-medium lg:mb-6">
    Curatorial selections that include works by {artistName}

    <span class="align-top text-xs font-medium">{selectionsData.total_count}</span>
  </h3>

  <SelectionList list="{selectionsData.selections}" />
</section>
